import logo from './logo.svg';
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useParams,
  Routes,
  Navigate,
  Link,
  useNavigate,useLocation ,
} from "react-router-dom";

import React, {
  Component,
  useEffect,
  useState,
  useCallback,
  useContext,
} from "react";
import { Button, ModalHeader, Table } from "react-bootstrap";
import Home from './Components/Home';
import Login from './Auth/Login';
import Signup from './Auth/Signup';
import UserOTP from './Auth/UserOTP';
import PasswordChange from './Auth/PasswordChange';
// import ForgotPassword from './Auth/ForgotPassword';
import GoJapan from './Components/GoJapan';
import StudyJobInJapan from './Components/StudyJobInJapan';
import Profile from './Components/Profile';
import Feedback from './Components/Feedback';
import ThankYouFeedback from './Components/ThankYouFeeback';
import LanguageSelection from './Components/Language';
import LearningJourney from './Components/LearningJourney';
import NewLearningJourney from './Components/NewLearningJourney';
import DayModule from './Components/DayModule';
import Learn from './Components/Learn';
import LearnScript from './Components/LearnScript';
import LearnVocabulary from './Components/LearnVocabulary';
import LeactureVideo from './Components/LeactureVideo';
import WritingPratice from './Components/WritingPractice';
import JLPTQuiz from './Components/JLPTQuiz';
import LifeInJapan from './Components/LifeInJapan';
import Manga from './Components/Manga';
import ReadingQuiz from './Components/ReadingQuiz';
import MockTestReadingQuiz from './Components/MockTestReadingQuiz';
import QDontTry from './Components/QDontTry';
import JapanHSchool from './Components/JapanHSchool';
import OldLifeJapan from './Components/OldLifeJapan';
import JapaneseOfficeWorker from './Components/JapaneseOfficeWorker';
import JapaneseChef from './Components/JapaneseChef';
import LifeOldJapanDay1 from './Components/LifeOldJapanDay1';
import LifeOldJapanDay0 from './Components/LifeOldJapanDay0';
import QuizResult from './Components/QuizResult';
import StartQuiz from './Components/StartQuiz';
import LifeOldJapanVoice from './Components/LifeOldJapanVoice';
import JapaneseHSchoolDay1 from './Components/JapaneseHSchoolDay1';
import SignupOtp from './Auth/SignupOtp';
import CurrentStatus from './Auth/CurrentStatus';
import GrammarQuiz from './Components/GrammarQuiz';
import ListeningQuiz from './Components/ListeningQuiz';
import MockTestListeningQuiz from './Components/MockTestListeningQuiz';
import ListeningQuizThankYou from './Components/ListeningQuizThankYou';
import KanjiQuiz from './Components/KanjiQuiz';
import Plans from './Components/Plans';
import TakeQuiz from './Components/TakeQuiz';
import ThankYouQuiz from './Components/ThankYouQuiz';
import KanjiQuizMain from './Components/KanjiQuizMain';
import KatakanaQuiz from './Components/KatakanaQuiz';
import HiraganaQuiz from './Components/HiraganaQuiz';
import VocabQuiz from './Components/VocabQuiz';
import QWantTry from './Components/QWantTry';
import WritingQuiz from './Components/WritingQuiz';
import NextQuiz from './Components/NextQuiz';
import Header from './Components/Common_Components/Header';
import Writting from './Components/Writting';
import Results from './Components/Results';
import ReattemptQuestion from './Components/ReattemptQuestion';
import ComingSoon from './Components/ComingSoon';
import LearningQuizResult from './Components/LearningQuizResult';
import ModuleSkit from './Components/ModuleSkit';
import ModuleThanks from './Components/ModuleThanks';
import ModuleListening from './Components/ModuleListening';
import PracticePage from './Components/PracticePage';
import Statistics from './Components/Statistics';
import QuizPage from './Components/QuizPage';
import FlashCard from './Components/FlashCard';
import FlashFinish from './Components/FlashFinish';
import Chat from './Components/Chat';
import ChatWithStaff from './Components/ChatWithStaff';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import LearningMaterials from './Components/LearningMaterial/LearningMaterials';
import HiraganaWorksheet from './Components/LearningMaterial/HiraganaWorksheet';
import KatakanaWorksheet from './Components/LearningMaterial/KatakanaWorksheet';
import ThankYouWritingQuiz from './Components/ThankYouWritingQuiz';
import KanjiWorksheet from './Components/LearningMaterial/KanjiWorksheet';
import Vocab from './Components/LearningMaterial/Vocab';
import PrivacyPolicyPage from './Components/Legal/PrivacyPolicyPage';
import RefundPolicyPage from './Components/Legal/RefundPolicyPage';
import CancellationPolicyPage from './Components/Legal/CancellationPolicyPage';
import PaymentStatus from './Components/Payment/PaymentStatus';
import AppView from './Components/AppView';
import PlansApp from './Components/PlansApp';
function App() {
  const navigate = useNavigate();
  const location = useLocation();

  // App ka "Continue on Website" -> /plansapp?from=app&token=... : browser me bhi app wala hi account use ho,
  // warna browser me pehle se login koi aur account plan check / payment me use ho jata hai
  const appLinkParams = new URLSearchParams(location.search);
  const appLinkToken = appLinkParams.get("from") === "app" ? appLinkParams.get("token") : null;
  if (appLinkToken && localStorage.getItem("AuthToken") !== appLinkToken) {
    localStorage.setItem("AuthToken", appLinkToken);
  }

  const authToken = localStorage.getItem("AuthToken");

  if (authToken) {
    try {
      const base64Url = authToken.split('.')[1];
      if (base64Url) {
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          window.atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        );
        const decoded = JSON.parse(jsonPayload);
        if (decoded && decoded.language) {
          const tokenLang = decoded.language;
          const currentLang = localStorage.getItem("selectedLanguage");
          if (currentLang !== tokenLang) {
            localStorage.setItem("selectedLanguage", tokenLang);
          }
        }
      }
    } catch (e) {
      console.error("Error parsing language from token in App.js:", e);
    }
  }

  // Inside the React Native app (react-native-webview), users without a plan see AppView first
  const isReactNativeApp = typeof window !== "undefined" && !!window.ReactNativeWebView;
  const noPlanRoute = isReactNativeApp ? "/AppView" : "/plans";

  const [subscriptionChecked, setSubscriptionChecked] = useState(false);
  const [isPlanRestricted, setIsPlanRestricted] = useState(false);

  useEffect(() => {
    const checkUserSubscription = async () => {
      if (!authToken) {
        localStorage.removeItem("planRestricted");
        setSubscriptionChecked(true);
        setIsPlanRestricted(false);
        return;
      }
      setSubscriptionChecked(false);

      try {
        const baseUrl = process.env.REACT_APP_BASE_URL || "https://api.japaking.online";
        const response = await fetch(`${baseUrl}/api/user-subscription`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
            Accept: "application/json",
          },
        });

        let data = null;
        try {
          data = await response.json();
        } catch (error) {
          data = null;
        }

        const plans = data?.message?.plan;
        const now = new Date();
        const hasActivePlan = Array.isArray(plans) && plans.some(p => {
          const activity = p.Activity_Status ? String(p.Activity_Status).toLowerCase() : "";
          return activity === "active" || 
                 activity === "trial" || 
                 activity === "trail" || 
                 (new Date(p.start_date) <= now && new Date(p.end_date) >= now && p.status === "active");
        });

        // FooterNav isi flag se decide karta hai ki RN app me tabs AppView par bheje ya nahi
        localStorage.setItem("planRestricted", hasActivePlan ? "false" : "true");
        if (hasActivePlan) {
          setIsPlanRestricted(false);
        } else {
          setIsPlanRestricted(true);
        }
      } catch (error) {
        localStorage.setItem("planRestricted", "true");
        setIsPlanRestricted(true);
      } finally {
        setSubscriptionChecked(true);
      }
    };

    checkUserSubscription();
  }, [authToken, location.pathname]);

  useEffect(() => {
    if (!authToken || !subscriptionChecked || !isPlanRestricted) return;

    const allowedRoutes = ["/plans", "/PlansApp", "/AppView", "/profile", "/payment/success", "/payment/failed", "/payment/cancelled"];
    // Route matching case-insensitive hai (/plansapp == /PlansApp), isliye yahan bhi waise hi check karo
    if (!allowedRoutes.some(route => route.toLowerCase() === location.pathname.toLowerCase())) {
      navigate(noPlanRoute, { replace: true });
    }
  }, [authToken, subscriptionChecked, isPlanRestricted, location.pathname, navigate, noPlanRoute]);

  // App (WebView) last page restore karti hai -> browser me payment ke baad bhi AppView par atke rehte the.
  // Plan active hai aur app khulte hi (restored page) AppView par hai to Home par bhejo.
  // Footer ke Payment tab se AppView kholna allowed hai, isliye sirf initial entry (key "default") par redirect.
  useEffect(() => {
    if (!isReactNativeApp || !authToken || !subscriptionChecked || isPlanRestricted) return;

    if (location.pathname.toLowerCase() === "/appview" && location.key === "default") {
      navigate("/", { replace: true });
    }
  }, [isReactNativeApp, authToken, subscriptionChecked, isPlanRestricted, location.pathname, location.key, navigate]);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={authToken ? <Home /> : <Navigate to="/login" replace />} />
        <Route
          path="/login"
          element={
            authToken
              ? <Navigate to={subscriptionChecked && isPlanRestricted ? noPlanRoute : "/"} replace />
              : <Login />
          }
        />
        <Route path="/signup" element={<Signup />} />
        <Route path="/current-status" element={authToken ? <CurrentStatus /> : <Navigate to="/login" replace />} />
        <Route path="/user-otp" element={<UserOTP />} />
        <Route path="/password-change" element={<PasswordChange />} />
        {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
        <Route path="/go-japan" element={<Navigate to="/plans" replace />} />
        <Route path="/study-job-in-japan" element={<StudyJobInJapan />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/thank-you" element={< ThankYouFeedback />} />

        <Route path="/language" element={<LanguageSelection />} />
        <Route path="/learning-journey" element={<LearningJourney />} />
        <Route path="/new-learning-journey" element={<NewLearningJourney />} />
        <Route path="/day-module" element={<DayModule />} />
        {/* <Route path="/day-module/:ModuleId/:ModuleNameName" element={<DayModule />} /> */}
        <Route path="/learn" element={<Learn />} />
        <Route path="/learn-script" element={<LearnScript />} />
        <Route path="/learn-vocabulary" element={<LearnVocabulary />} />
        <Route path="/thank-you-quiz" element={<ThankYouQuiz />} />
        <Route path="/leacture-video" element={<LeactureVideo />} />
        <Route path="/writing-pratice" element={<WritingPratice />} />
        <Route path="/Learn" element={<Learn />} />
        <Route path="/JLPTQuiz" element={<JLPTQuiz />} />
        <Route path="/LifeInJapan" element={<LifeInJapan />} />
        <Route path="/Manga" element={<Manga />} />
        <Route path="/QDontTry" element={<QDontTry />} />
        <Route path="/JapanHSchool" element={<JapanHSchool />} />
        <Route path="/OldLifeJapan" element={<OldLifeJapan />} />
        <Route path="/JapaneseOfficeWorker" element={<JapaneseOfficeWorker />} />
        <Route path="/JapaneseChef" element={<JapaneseChef />} />
        <Route path="/LifeOldJapanDay1" element={<LifeOldJapanDay1 />} />
        <Route path="/LifeOldJapanDay0" element={<LifeOldJapanDay0 />} />
        <Route path="/QuizResult" element={<QuizResult />} />
        <Route path="/StartQuiz" element={<StartQuiz />} />
        <Route path="/LifeOldJapanVoice" element={<LifeOldJapanVoice />} />
        <Route path="/Grammar/:category_id" element={<GrammarQuiz />} />
        <Route path="/ListeningQuiz" element={<ListeningQuiz />} />
        <Route path="/MockTestListeningQuiz" element={<MockTestListeningQuiz />} />
        <Route path="/ListeningQuizThankYou" element={<ListeningQuizThankYou />} />
        <Route path="/:category_name/:category_id/3i" element={<KanjiQuiz />} />
        <Route path="/JapaneseHSchoolDay1" element={<JapaneseHSchoolDay1 />} />
        <Route path="/signup-otp" element={<SignupOtp />} />
        <Route path="/take-quiz" element={<TakeQuiz />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/plansapp" element={<PlansApp />} />

        <Route path="/AppView" element={<AppView />} />
        <Route path="/KanjiQuizMain" element={<KanjiQuizMain />} />
        <Route path="/KatakanaQuiz" element={<KatakanaQuiz />} />
        <Route path="/HiraganaQuiz" element={<HiraganaQuiz />} />
        <Route path="/VocabQuiz" element={<VocabQuiz />} />
        <Route path="/QWantTry" element={<QWantTry />} />
        <Route path="/writing-quiz" element={<WritingQuiz />} />
        <Route path="/next-quiz" element={<NextQuiz />} />
        <Route path="/:quiz_type_name/:quiz_type_id/4" element={<KanjiQuizMain />} />
        {/* <Route path="/:quiz_type_name/:quiz_type_id/2" element={<KatakanaQuiz/>}/>
      <Route path="/:quiz_type_name/:quiz_type_id/1" element={<HiraganaQuiz/>}/>
      <Route path="/:quiz_type_name/:quiz_type_id/3" element={<VocabQuiz/>}/> */}
        <Route path="/QWantTry" element={<QWantTry />} />
        <Route path='/Writing/:category_id/:1a' element={<Writting />} />
        <Route path="/ReadingQuiz" element={<ReadingQuiz />} />
        <Route path="/MockTestReadingQuiz" element={<MockTestReadingQuiz />} />
        <Route path="/results" element={<Results />} />
        <Route path="/ReattemptQuestion" element={<ReattemptQuestion />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/learning-quiz-result" element={<LearningQuizResult />} />
        <Route path="/ModuleSkit" element={<ModuleSkit />} />
        <Route path="/ModuleThanks" element={<ModuleThanks />} />
        <Route path="/ModuleListening" element={<ModuleListening />} />
        <Route path="/PracticePage" element={<PracticePage />} />
        <Route path="/Statistics" element={<Statistics />} />
        <Route path="/QuizPage" element={<QuizPage />} />
        <Route path="/FlashCard" element={<FlashCard />} />
        <Route path="/FlashFinish" element={<FlashFinish />} />
        <Route path="/LearningMaterials" element={<LearningMaterials />} />

        <Route path="/HiraganaWorksheet" element={<HiraganaWorksheet />} />
        <Route path="/KatakanaWorksheet" element={<KatakanaWorksheet />} />
        <Route path="/KanjiWorksheet" element={<KanjiWorksheet />} />
        <Route path="/Vocab" element={<Vocab />} />
        <Route path="/thankyouwritingquiz" element={<ThankYouWritingQuiz />} />
        <Route path="/Chat" element={<Chat />} />
        <Route path="/chat-with-staff" element={<ChatWithStaff />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
        <Route path="/cancellation-policy" element={<CancellationPolicyPage />} />
        <Route path="/payment/success" element={<PaymentStatus status="success" />} />
        <Route path="/payment/failed" element={<PaymentStatus status="failed" />} />
        <Route path="/payment/cancelled" element={<PaymentStatus status="cancelled" />} />
      </Routes>
    </div>

  );
}

export default App;
